/* @flow */

import { type Pedido, type Etapa } from './types';

const atualizarEtapaPedido = (pedido: Pedido, etapa: Etapa): Pedido => {
    if (pedido.etapasId === etapa.etapasId) {
        return pedido;
    }

    return {
        ...pedido,
        etapasId: etapa.etapasId,
        etapa,
        etapas: [...(pedido.etapas || []), etapa],
    };
};

export default atualizarEtapaPedido;
